import { ICustomersFilterState } from 'components/customersPage/filters/customersFilter.types'
import {
  CustomersSortField,
  CustomersSortOrder,
} from 'components/customersPage/customersTable/CustomersTableHead'
import { ICustomersListQuery } from 'handlers/buildCustomersQueryParams'

interface BuildCustomersListRequestParams {
  /** Применённые фильтры таблицы */
  filters: ICustomersFilterState
  /** Поле сортировки */
  orderBy: CustomersSortField
  /** Направление сортировки */
  order: CustomersSortOrder
  /** Лимит страницы */
  limit: number
  /** Смещение */
  offset: number
}

/**
 * Собирает query для GET /users из состояния страницы клиентов.
 * @param params — фильтры, сортировка и пагинация
 */
export const buildCustomersListRequest = (
  params: BuildCustomersListRequestParams,
): ICustomersListQuery => {
  const { filters, orderBy, order, limit, offset } = params

  return {
    limit,
    offset,
    first_name: filters?.first_name || undefined,
    last_name: filters?.last_name || undefined,
    phone: filters?.phone || undefined,
    email: filters?.email || undefined,
    city: filters?.city || undefined,
    pizzeria_id: filters?.pizzeria_id ?? undefined,
    sortBy: orderBy,
    sortOrder: order === 'asc' ? 'ASC' : 'DESC',
  }
}

interface BuildCustomersExportBaseQueryParams {
  /** Применённые фильтры таблицы */
  filters: ICustomersFilterState
  /** Поле сортировки */
  orderBy: CustomersSortField
  /** Направление сортировки */
  order: CustomersSortOrder
}

/**
 * Фильтры и сортировка без пагинации — для полной выгрузки в Excel.
 * @param params — фильтры и сортировка
 */
export const buildCustomersExportBaseQuery = (
  params: BuildCustomersExportBaseQueryParams,
): Omit<ICustomersListQuery, 'limit' | 'offset'> => {
  const listRequest = buildCustomersListRequest({
    ...params,
    limit: 1,
    offset: 0,
  })

  return {
    first_name: listRequest.first_name,
    last_name: listRequest.last_name,
    phone: listRequest.phone,
    email: listRequest.email,
    city: listRequest.city,
    pizzeria_id: listRequest.pizzeria_id,
    sortBy: listRequest.sortBy,
    sortOrder: listRequest.sortOrder,
  }
}
